import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Caught render error:", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false });
    if (typeof window !== "undefined") window.location.assign("/");
  };

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="app-error-fallback" className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6 py-16">
          <h1 className="font-heading font-extrabold text-2xl md:text-3xl text-metros-black">Something went wrong</h1>
          <p className="text-sm text-muted-foreground mt-2 max-w-md">
            We hit a snag loading this. Please head back and try again — your basket is safe.
          </p>
          <button
            data-testid="app-error-home-btn"
            onClick={this.handleReset}
            className="mt-6 bg-metros-red hover:bg-metros-redhover text-white rounded-full px-6 py-3 font-bold active:scale-95 transition-all"
          >
            Back to home
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
